import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarClock, ListChecks, Clock, LogIn, Timer, AlertCircle } from "lucide-react";

function fmtMinutes(mins) {
  if (!mins) return "0h 0m";
  return `${Math.floor(mins / 60)}h ${Math.round(mins % 60)}m`;
}

export default function DashboardScheduleSummary() {
  const [summary, setSummary] = useState(null);
  const [attendance, setAttendance] = useState(null);

  useEffect(() => {
    api.get("/schedule/dashboard-summary").then((r) => setSummary(r.data)).catch(() => {});
    api.get("/attendance/today").then((r) => setAttendance(r.data)).catch(() => {});
  }, []);

  if (!summary) return null;
  const isCheckedIn = attendance && !attendance.check_out_time;
  const netMinutes = attendance?.net_minutes;

  const items = [
    { icon: CalendarClock, label: "Today's Lectures", value: summary.todays_lectures },
    { icon: ListChecks, label: "Tasks", value: summary.todays_tasks },
    { icon: Clock, label: "Available Hours", value: `${summary.available_hours}h` },
    { icon: LogIn, label: "Check-in Status", value: isCheckedIn ? "Checked In" : "Not Checked In" },
    { icon: Timer, label: "Time Worked", value: netMinutes != null ? fmtMinutes(netMinutes) : isCheckedIn ? "In progress" : "—" },
    { icon: AlertCircle, label: "Pending Tasks", value: summary.pending_tasks },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-testid="schedule-attendance-dashboard-summary">
      {items.map(({ icon: Icon, label, value }) => (
        <div key={label} className="bg-white border border-[#E2E8F0] rounded-lg p-3.5">
          <Icon className="h-4 w-4 text-[#00823B] mb-1.5" />
          <p className="text-[10px] uppercase tracking-wide text-[#4B5563] font-semibold">{label}</p>
          <p className="text-sm font-bold text-[#1C1C1E] mt-0.5">{value}</p>
        </div>
      ))}
    </div>
  );
}
